import { ChevronRightIcon } from '@bp/ui-components';
import classNames from 'classnames';
import { FC, ReactNode, useEffect, useRef } from 'react';
import { IllustrativeIcon } from '../IllustrativeIcon/IllustrativeIcon';
import styles from './IconMenuItem.module.scss';

type IconMenuItemProps = {
  icon: ReactNode;
  iconSize?: number;
  bubbleType?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16 | 17 | 18;
  label: string;
  /** Kleiner Hinweis neben der Kachel, z. B. der Omni-Chip */
  badge?: ReactNode;
  active?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
};

export const IconMenuItem: FC<IconMenuItemProps> = ({
  icon,
  iconSize,
  bubbleType,
  label,
  badge,
  active,
  disabled,
  onClick,
  className,
}) => {
  const ref = useRef<HTMLDivElement>(null);

  // in der wischbaren Pillen-Leiste (IconMenu variant='tabs') den aktiven Eintrag sichtbar machen
  useEffect(() => {
    const el = ref.current;
    if (!active || !el?.closest('[data-icon-menu-variant="tabs"]')) return;
    const bar = el.parentElement;
    if (bar && bar.scrollWidth > bar.clientWidth) {
      bar.scrollLeft = el.offsetLeft - (bar.clientWidth - el.offsetWidth) / 2;
    }
  }, [active]);

  const classes = classNames(
    styles['icon-menu-item'],
    { [styles.active]: active, [styles.disabled]: disabled || !onClick },
    className,
  );

  return (
    <div
      ref={ref}
      className={classes}
      onClick={() => {
        !disabled && onClick && onClick();
        // prevent double click (thus double navigating) while UI is loading/unresponsive
        disabled = true;
      }}
    >
      <IllustrativeIcon
        icon={icon}
        size={iconSize}
        bubbleType={bubbleType}
        isActive={active}
        disabled={disabled || !onClick}
      />
      {badge ? <span className={styles.badge}>{badge}</span> : null}
      <span className={styles.label}>{label}</span>
      <ChevronRightIcon className={styles.chevron} aria-hidden />
    </div>
  );
};
